import React from 'react';
import QRCode from 'qrcode.react';
import { addContentPath } from '../../../util/pathUtil';

class E9QRCode extends React.Component {
    constructor(props) {
        super(props);
        this.onRefresh = this.onRefresh.bind(this);
        this.onDownload = this.onDownload.bind(this);
    }

    componentDidMount() {
        const { loginstate = {} } = this.props;
        const { cacheAccount: loginId, langId } = loginstate;
        this.props.getLoginForm({ loginId, langId }, () => this.props.onQCLoginStart());
    }

    componentWillUnmount() {
        this.props.onQCLoginEnd();
    }

    render() {
        const {  loginstate= {}, qrcodeIsInvalid ,emobileDownloadUrl}=this.props;
        const {loginSettingInfo = {},labelInfo,langId,qrCode} = loginstate;
        let labelObj=labelInfo[`langid${langId}`] || {};
        const size = 200;

        return (
            <div className="e9login-pop-QRCode">
                <div className="e9login-pop-QRCode-area">
                    {qrcodeIsInvalid && (
                        <div className="e9login-pop-QRCode-timeout">
                            <div className="e9login-pop-QRCode-timeout-mask" />
                            <div className="e9login-pop-QRCode-timeout-tips">{labelObj.qrcodeisinvalid}</div>
                            <i className="icon-coms-Refresh e9login-pop-QRCode-timeout-refresh" title={labelObj.refresh} onClick={this.onRefresh} />
                        </div>
                    )}
                    {qrCode.text ? <QRCode value={qrCode.text} size={size} fgColor="#404549" bgColor="#ffffff" /> : ''}
                </div>
                <div className="e9login-pop-QRCode-describe" >{labelObj.qrcode}</div>
                {emobileDownloadUrl && <div className="e9login-pop-QRCode-download" onClick={this.onDownload}>{labelObj.download}</div>}
            </div>
        );
    }

    onRefresh() {
        const { loginstate = {} } = this.props;
        const { cacheAccount: loginId, langId } = loginstate;
        this.props.getLoginForm({ loginId, langId }, () => this.props.onQCLoginStart());
    }

    onDownload() {
        const {  emobileDownloadUrl}=this.props;
        window.open(addContentPath(emobileDownloadUrl));
    }
}

export default E9QRCode;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-login-pop/e9login/E9QRCode.js